import * as z from "zod";
import { hsaAnswer } from "../hsa-answer";
import { hsaSessionState } from "./types";

// Handoff twin of rewindHsaGroup: same stateless walk as the forward call
// (client-held answers, nothing persisted), returning the predecessor step.
export const getHandoffSurveyPreviousGroupInput = z.object({
  sessionToken: z.string().uuid(),
  answers: z.record(z.string(), hsaAnswer),
  currentStepHandle: z.string().min(1),
});

export const getHandoffSurveyPreviousGroupOutput = z.object({
  state: hsaSessionState,
});
